export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const initialFilter = {
  searchKey: "",
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10,
};

// Per-user "Show Cue Tips" preference for the Purchase Order screen. Stored alongside the other
// per-user cart settings (admin_panel / SaleOrder.cart.Product), but under its own key so it is
// independent of the Sale Order cue tip toggle. Defaults to on, matching the previous behaviour.
export const PO_CUE_TIP_SETTING_KEY = "showPOCueTip";
export const isPOCueTipEnabled = (basicSettingsEntity, userId) =>
  basicSettingsEntity?.SALE_SETTING?.[userId]?.[PO_CUE_TIP_SETTING_KEY] !== false;
